import React from "react"
import PropTypes from "prop-types"
import { Gallery as PhotoSwipe, Item } from "react-photoswipe-gallery"
import styled, { createGlobalStyle } from "styled-components"
import { breakpoints } from "../../../theme"
import { CmsImage } from "@bw/bits"

const ImageStyle = createGlobalStyle`
  .pswp__img {
    object-fit: contain
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 124px;
  grid-gap: 15px;

  @media (max-width: ${breakpoints.medium - 1}px) {
    > :nth-child(1) {
      grid-column: 1 / 3;
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    display: grid;
    grid-gap: 17px;
    grid-template-columns: 2fr 1fr 1fr;
    grid-auto-rows: 230px;
  }

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;

    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
      cursor: pointer;

      @media (min-width: ${breakpoints.medium}px) {
        height: 230px;
      }
    }
  }
`

const Gallery = ({ images }) => {
  return (
    <PhotoSwipe
      shareButton={false}
      fullscreenButton={false}
      options={{
        hideAnimationDuration: 0,
        showAnimationDuration: 0,
      }}
    >
      <ImageStyle />
      <Grid>
        {images.map((image, i) => (
          <Item
            key={i}
            original={
              image?.localImage?.childImageSharp?.original?.src || image.url
            }
            width={image?.localImage?.childImageSharp?.original?.width}
            height={image?.localImage?.childImageSharp?.original?.height}
          >
            {({ ref, open }) => (
              <div ref={ref} onClick={open}>
                <CmsImage src={image} alt={image.alt} />
              </div>
            )}
          </Item>
        ))}
      </Grid>
    </PhotoSwipe>
  )
}

Gallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      thumbnail: PropTypes.object,
      image: PropTypes.string,
      height: PropTypes.string,
      width: PropTypes.string,
    })
  ),
}

export { Gallery }
